import {Injectable} from "@angular/core";
import {Action, State, StateContext} from "@ngxs/store";
import {AppInitialState, AppStateModel} from "@store/models/app.model";
import {AppActions} from "@store/actions/app.actions";

@State<AppStateModel>({
  name: 'AppState',
  defaults: AppInitialState,
})
@Injectable()
export class AppState {
  @Action(AppActions.setUserInfo)
  setUserInfo(ctx: StateContext<AppStateModel>, action: AppActions.setUserInfo) {
    ctx.patchState({ userInfo: action.payload });
  }
}
